// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_v7-","col":"styles_col__1D0n9"};